import React from 'react';
import logo from '../assets/images/serty-logo.png';
import netlogo from '../assets/images/sernet.png';
import plug from '../assets/images/serty_footer_pic.png';
import './App.css';
import { Button, Container, Row, Col, Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl'; 
import history from './History';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

import { MsalContext, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "../util/authUtil";

library.add(fas);

export default class App extends React.Component {

  static contextType = MsalContext;

  navigateToHome() {
    history.push('/Home');
  }

  async signIn() {
    try {
      await this.context.instance.loginPopup(loginRequest);
      this.navigateToHome();
    } catch (error) {
      //login failure
      console.log(error);
    }
  }

  render() {
    return (
      <UnauthenticatedTemplate>
        <Container fluid className="App">
          <div className="Login-Sidebar-Overlay"></div>
          <Row>
              <Col className="Main-Logo"><img src={logo}  alt="logo" /></Col>
              <Col className="Net-Logo"> <img src={netlogo} alt="netlogo" /></Col>
          </Row>
          <Form className="Login-Sidebar">
            <Form.Row>
              <Col className="Header">
                <FormattedMessage id="login.login" />
                <br/>
                <FormattedMessage id="login.tosernet" />
              </Col>
            </Form.Row>
            <Form.Row className="Center">
              <Col>
                <Button onClick={() => this.signIn()} className="Login-Button" style={{background: "var(--serty-green)"}} >
                  <FormattedMessage id="login.loginbutton" />
                </Button>
              </Col>
            </Form.Row>
            <Form.Row className="Plug">
              <Col>
                <img src={plug} alt="plug" />
              </Col>
            </Form.Row>
          </Form>
        </Container>
      </UnauthenticatedTemplate>
    );
  }
}
